import { trackUserInput } from '@forwardfinancing/analytics-frontend-library';
import utils from './utils';

export const redirectIfAdmin = ({isAdmin, history}) => {
  if (isAdmin) {
    history && history.replace("/portal");
  }
};

export default {
  getReferredPage(source={}){
    const {document} = source;
    return this.getCapitalizedPathname(document && document.referrer);
  },

  getCapitalizedPathname(path) {
    let lastWord = this.getLastWordFromUrl(path);
    lastWord = this.checkHomepage(lastWord);
    return this.camelCaseString(lastWord);
  },

  renewalLink({source, uuid, dba}) {
    return (
      {
        text: 'Apply for Renewal',
        href: `/portal/renewal_submission?uuid=${uuid}&dba=${dba}`,
        source
      }
    );
  },

  stipsLink({uuid, dba}) {
    return (
      {
        text: 'Submit Stipulations',
        href: `/portal/stipulations?uuid=${uuid}&dba=${dba}`
      }
    );
  },

  trackStep({step, source, label, shortened_form=false, dba, googleBusinessLookupUsed=false}) {
    if (step) {
      trackUserInput({
        step,
        source: this.getReferredPage(source),
        label,
        shortened_form,
        dba,
        googleBusinessLookupUsed
      });
    }
  },

  checkHomepage(string) {
    if (this.isValidString(string) && string === 'portal') {
      return 'home';
    }
    return string;
  },

  isValidString(string) {
    return typeof string === 'string';
  },

  capitalizeFirstLetter(string) {
    if (this.isValidString(string)) {
      const firstLetter = string.charAt(0).toUpperCase();

      return firstLetter + string.slice(1);
    } else {
      return '';
    }
  },

  mapArrayAndCapitalizeWords(words) {
    if (utils.isArray(words)) {
      return words.map(this.capitalizeFirstLetter.bind(this));
    }
  },

  joinArray(array, separator=' ') {
    return utils.isArray(array) && array.join(separator);
  },

  isMoreThanOneWord(string) {
    return this.isValidString(string) && string.indexOf('_') !== -1;
  },

  camelCaseString(string) {
    if (this.isMoreThanOneWord(string)) {
      const words = string.split('_');
      const newArray = this.mapArrayAndCapitalizeWords(words);

      return this.joinArray(newArray);
    } else {
      return this.capitalizeFirstLetter(string);
    }
  },

  getLastWordFromUrl(string) {
    if (this.isValidString(string)) {
      const lastWordWithParams = string.split('/').pop();
      return lastWordWithParams.split('?').shift();
    } else {
      return '';
    }
  },

  getLocationName(props) {
    const {location} = props || {};
    const path = location && location.pathname;
    return (path && this.getCapitalizedPathname(path)) || '';
  }
};
